import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BaseComponent } from '../base.component';
import { ModalsStore } from '../core-services/modals/modals.store';
import { UserDetails } from '../core-services/user/user.model';
import { UserStore } from '../core-services/user/user.store';
import { Menu, MenuTypes } from './menu.models';
import { Languages, PrefixLangs } from '../core-services/core.models';
import { CoreService } from '../core-services/core.service';
import { VisitorStore } from '../core-services/visitor/visitor.store';
import { GameFilterCategoriesService } from '../games-filter/games-filter-categories.service';
import { GameProvider, GameTypeFilter } from '../games-filter/games-filter-categories.models';
import { gameFilterCategoriesConfigPopularStudios } from '../games-filter/games-filter-categories.config';

export const MENU_SELECTOR = "whg-menu";
@Component({
  selector: MENU_SELECTOR,
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [GameFilterCategoriesService],
})
export class MenuComponent extends BaseComponent implements OnInit {
  userDetails$: Observable<UserDetails> = this.userStore.userDetails$.pipe(filter(x => !!x));
  menuType: string;
  config: Menu;
  loggedIn: boolean;
  languages = Languages;
  allProviders: GameTypeFilter[] = [];
  popularProviders: GameTypeFilter[] = gameFilterCategoriesConfigPopularStudios.filterTypes;
  providersExpanded: boolean = false;
  allProvidersExpanded: boolean = false;

  /*
  * Additional text from config
  */
  depositBtnText: string;
  langOptionsText: string;
  showMoreBtn: string;
  showLessBtn: string;

  get currentLang(): string {
    return Languages[this.translate.currentLang.toUpperCase()];
  }

  constructor(
    private userStore: UserStore,
    private readonly modalsStore: ModalsStore,
    public coreService: CoreService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private visitorStore: VisitorStore,
    private gameFilterCategoriesService: GameFilterCategoriesService,
    private cdr: ChangeDetectorRef
  ) {
    super(PrefixLangs.Menu);
  }

  ngOnInit(): void {
    this.gameFilterCategoriesService
      .getGameProviders()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: GameProvider[]) => {
        data.forEach((value: GameProvider) => {
          this.allProviders.push({
            label: value.title,
            iconPath: `/assets/games-filter/studio/${value.title}.png`,
            redirectUrl: `/games?provider=${this.gameFilterCategoriesService.createProviderId(
              value.title
            )}`,
          });

          this.cdr.detectChanges();
        });
      });
    this.userStore.addUserDetails(this.coreService.getUserDetails());
    this.userDetails$.pipe(takeUntil(this.destroy$), filter(x => !!x)).subscribe(userDetails => {
      if (userDetails.userid) {
        this.loggedIn = true;
      }
    });
    /*
     * Set language if any from the cookie, get configuration and listen for language switching
     */
    this.visitorStore.jurisdication$.pipe(takeUntil(this.destroy$)).subscribe(jurisdiction => {
      this.jurisdiction = jurisdiction;
      super.ngOnInit();
      this.config$.pipe(takeUntil(this.destroy$)).subscribe((menuConfig: Menu) => {
        this.depositBtnText = menuConfig.depositBtn;
        this.langOptionsText = menuConfig.langOptions;
        this.showLessBtn = menuConfig.showLessBtn;
        this.showMoreBtn = menuConfig.showMoreBtn;
        this.setMenu(menuConfig);
      });
      this.modalsStore.menuModalConfig$
        .pipe(takeUntil(this.destroy$))
        .subscribe((config: string) => {
        this.menuType = config;
      });
    });
  }

  setMenu(menuConfig: Menu): void {
    if(this.loggedIn) {
      this.config = menuConfig[MenuTypes.LoggedIn];
    } else {
      this.config = menuConfig[MenuTypes.LoggedOut];
    }
  }

  switchLanguage(language: string): void {
    this.coreService.switchLanguage(language);
  }

  hideSubmenuOnDesktop(shownOnDesktop: boolean): boolean {
    return this.coreService.getScreenWidthFromWindow() > 768 ? shownOnDesktop : true;
  }

  hideMenuResponsibleGambling(pageUrl: string): boolean {
    return this.loggedIn ? (this.coreService.isCurrentPathContains('activate&token')
    || this.coreService.isCurrentPathContains('page=marketingprefs')
    || this.coreService.isCurrentPathContains('page=messages&message')) ? pageUrl === '/logout' : true : true;
  }

  closeModal(): void {
    this.activeModal.close();
  }

  checkLoggout(link: string): void {
    if(link === '/logout') {
      this.coreService.clearUserDetails();
    }
  }

  toggleExpand(): void {
    this.providersExpanded = !this.providersExpanded;
  }

  gotToProvidersPage(): void {
    window.location.href = '/providers';
  }

}
